import i18n from "i18";

const appTitle = "Connexxtion";

const _helper = {
    cookie(name, value, props = {}) {
        const l = arguments.length;

        if (l > 1) {
            let cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

            if (props?.toFixed)
                props = { expires: props };
            if (props?.expires?.toFixed) {
                const date = new Date();
                date.setDate(date.getDate() + (props.expires || -1));
                props.expires = date;
            }
            if (props?.expires?.toUTCString)
                props.expires = props.expires.toUTCString();

            if (!props?.path)
                props.path = "/";
            if (!props?.domain)
                props.domain = "";

            Object.entries(props).forEach(([key, val]) => {
                cookie += `; ${key}=${val}`;
            });

            document.cookie = cookie;

            return;
        }

        const c = document.cookie;
        const arr = c.length ? c.split(";") : [];

        const obj = {};
        arr.forEach(str => {
            const [key, val] = str.trim().split("=");

            obj[decodeURIComponent(key)] = decodeURIComponent(val);
        });

        return !l ? obj : obj[name];
    },

    formatBytes(bytes, decimals = 1) {
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        if (!bytes || !bytes?.toFixed)
            return `0 ${sizes[0]}`;

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },

    on(node, eventName, fName, useCapture) {
        const capt = !!useCapture;

        node.addEventListener(eventName, fName, capt);

        return {
            remove: () => {
                node.removeEventListener(eventName, fName, capt);
            }
        };
    },

    stopEvent(e) {
        if (e?.preventDefault?.apply)
            e.preventDefault();

        if (e?.stopPropagation?.apply)
            e.stopPropagation();
    },

    setFileSystem(node, cb) {
        if (!node || !("ondrop" in node))
            return;

        const cancelEv = e => {
            e.dataTransfer.dropEffect = "copy";
            this.stopEvent(e);
        };

        const setActive = e => {
            cancelEv(e);

            document.querySelectorAll(".dragActive").forEach(n => {
                if (n !== node)
                    n.classList.remove("dragActive");
            });

            node.classList.add("dragActive");
        };

        const unSetActive = (e, force) => {
            cancelEv(e);

            if (force || !node.contains(e.target))
                node.classList.remove("dragActive");
        };

        this.on(node, "dragenter", setActive);
        this.on(node, "dragover", setActive);
        this.on(node, "dragleave", unSetActive);

        this.on(node, "drop", e => {
            unSetActive(e, 1);

            const files = e.dataTransfer.files;
            if (!files?.length || !cb?.apply)
                return;

            cb(files);
        }, false);
    },

    getPageTitle() {
        const page = window.location.pathname.split("/").filter(it => !!it).at(-1);
        const trKey = `pages.${page}`;
        const tr = i18n.t(trKey);
        const pageText = trKey !== tr ? tr : "";
        const pageTitle = pageText ? `${appTitle} | ${pageText}` : appTitle;

        return { page, pageTitle, pageText };
    },

    formFilesAccept(obj) {
        return Object.keys(obj || {}).flatMap(key => {
            const type = key.toLocaleLowerCase().replace("allowed_", "");
            const value = obj[key];

            return (value || []).filter(it => !!it).map(it => `${type}/${it}`);
        }).join(",");
    },

    changeLang(lang) {
        globalThis.app.changeLang(lang);
    },

    logout() {
        globalThis.appView.logout();
    },

    alertError(text = "") {
        globalThis.appView.alertError(text);
    },

    startLoading(cb) {
        globalThis.appView.setLoading(true, cb);
    },

    endLoading(cb) {
        globalThis.appView.setLoading(false, cb);
    },

    showPreview(props) {
        globalThis.appView.showHidePreview(props);
    },

    confirm(text, onClick, title = "confirmation") {
        const t = text.at(0) === "^" ? text.slice(1) : i18n.t(text);

        globalThis.appView.showHideDialog({
            title,
            text: `${t} ?`,
            buttons: [{
                label: "cancel",
                variant: "outlined"
            },
            {
                label: "confirm",
                onClick
            }]
        });
    },

    abortCurrentRequest() {
        globalThis.requestCurrentController.abort();
    },

    getErrorMessage(e) {
        return e?.response?.data?.error || e?.message || "error";
    },

};

export default _helper;